<template>
    <div class="toolbar">
        <div class="container">
            <div class="row" style="display: flex; align-items: center">
                <div class="col" style="flex-shrink: 1; flex-grow: 0; white-space: nowrap;">
                    <a @click="$emit('back')" class="mr-3" style="cursor: pointer">
                        <span class="bi bi-arrow-left-circle-fill"></span>
                    </a>
                    <slot name="nav" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        //
    }
</script>